<template>
  <Copy element="div" v-if="!editMode" :staticClass="`${el}__personalDataWrapper`">
    <template>
      <div>
        <Copy element="div" size="s" color="tertiaryLight">E-Mail:</Copy>

        <Copy element="div" size="l" bold>
          {{ this.user.username }}
        </Copy>
      </div>

      <div class="u-margin__top--2">
        <Copy element="div" size="s" color="tertiaryLight">Passwort:</Copy>

        <Copy element="div" size="l" bold>*********</Copy>
      </div>

      <Link to="" icon="pencil-line" noUnderline @click="changeEditMode" class="u-margin__top--3">
        Bearbeiten
      </Link>
    </template>
  </Copy>

  <form v-else @submit.prevent="handleSubmit">
    <Copy
      v-if="statusCode === 403"
      size="m"
      color="supportDanger"
      centered
      bold
      responsive
      :staticClass="`${el}__personalDataFormError`"
    >
      {{ $t('profile.access.form.error.password.authentication.failed') }}
    </Copy>

    <Row>
      <Col :xs="12" :m="6" hasMargin>
        <BaseInput
          label="Altes Passwort"
          type="password"
          name="password"
          v-model="formFields.password.value"
          :error="formFields.password.error"
          @input="clearError(formFields.password)"
          clearable
        />
      </Col>
    </Row>
    <Row>
      <Col :xs="12" :m="6" hasMargin>
        <BaseInput
          label="Neues Passwort"
          type="password"
          name="newPassword"
          v-model="formFields.newPassword.value"
          :error="formFields.newPassword.error"
          @input="clearError(formFields.newPassword)"
          clearable
        />
      </Col>
    </Row>
    <Row>
      <Col :xs="12" :m="6" hasMargin>
        <PasswordStrength :password="formFields.newPassword.value" />
      </Col>
    </Row>

    <div :class="`${el}__buttonRow`">
      <Button
        :label="$t('profile.button.label.cancel')"
        type="outlined"
        @click="changeEditMode"
        small
      />
      <Button
        :label="$t('profile.button.label.save')"
        type="primary"
        :loading="loadForm"
        submit
        small
      />
    </div>
  </form>
</template>

<script>
import Vue from 'vue';
import Link from '@/objects/Link';
import Button from '@/objects/Button';
import BaseInput from '@/objects/Forms/BaseInput';
import Copy from '@/objects/Copy/Copy';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';
import PasswordStrength from '@/components/PasswordStrength';

import { passwordPattern } from '@/helpers/patterns';
import { validateForm } from '@/helpers/formValidation';

import { mapFieldsUser } from '@/store/mapFields';
import { AUTH_LOGOUT } from '@/store/actions/auth';

import { ROUTE_API_UPDATE_PASSWORD } from '@/constants/apiRoutes';
import { ROUTE_LOGIN } from '@/constants/routes';
import { createValidationData } from '@/helpers/tracking/validationTracking';

export default {
  name: 'AccessDataForm',
  props: {
    el: String,
  },
  components: {
    Copy,
    Link,
    Button,
    BaseInput,
    Row,
    Col,
    PasswordStrength,
  },
  computed: {
    ...mapFieldsUser(['user']),
  },
  watch: {
    editMode() {
      this.formFields.password.value = '';
      this.formFields.newPassword.value = '';
    },
  },
  data() {
    return {
      editMode: false,
      statusCode: '',
      loadForm: false,
      formFields: {
        password: {
          value: '',
          error: null,
          required: this.$t('profile.access.form.error.password.required'),
        },
        newPassword: {
          value: '',
          error: null,
          required: this.$t('profile.access.form.error.newPassword.required'),
          pattern: {
            value: passwordPattern,
            message: this.$t('profile.access.form.error.newPassword.formatted'),
          },
        },
      },
    };
  },
  methods: {
    handleSubmit(e) {
      this.loadForm = true;
      const { isValid } = validateForm(e.target.elements, this.formFields);

      if (isValid) {
        Vue.axios
          .post(ROUTE_API_UPDATE_PASSWORD, {
            password: this.formFields.password.value,
            newPassword: this.formFields.newPassword.value,
          })
          .then((response) => {
            this.statusCode = response.status;
            this.editMode = false;
            this.loadForm = false;
          })
          .catch((error) => {
            const {
              data: { errors },
              status,
            } = error.response;

            this.statusCode = status;

            // Error-Codes
            // 401 = unauthorized (cookie problem) or user blocked
            // 403 = wrong pw
            // 422: validation error

            if (status === 422) {
              Object.keys(errors).map((error) => {
                const type = errors[error][0];
                this.formFields[error].error = this.$t(
                  `profile.access.form.error.${error}.${type}`
                );
              });
            }

            if (status === 401) {
              this.$store
                .dispatch(AUTH_LOGOUT)
                .then(() => {
                  this.$router.push(ROUTE_LOGIN);
                })
                .catch(() => this.$router.push(ROUTE_LOGIN));
            }
            this.loadForm = false;
          });
      } else {
        createValidationData(this.formFields);
        this.loadForm = false;
      }
    },

    changeEditMode() {
      this.editMode = !this.editMode;
    },

    clearError(field) {
      field.error = null;
    },
  },
};
</script>
